import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import store from './Dashboard'
import FeedbackList from '../FeedbackList';
import FeedbackDetail from '../FeedbackDetail';
import SearchBar from '../SearchBar';
import StatsBar from '../StatsBar';
import StatsTable from '../StatsTable';
import Modal from '../Modal';
import Loading from '../Loading';
import {connectWebsocket, setSelectedFeedback, setNotificationPermission} from '../redux/FeedbackRedux';

class DashboardTables extends React.Component {
    
    constructor(props) {
		super(props);
	}

    render() {
            return (
                <div className="container-fluid">
                    <Loading location={'page'} />
                    <div className="row dashboard-stats">
                        <StatsBar/>
                        <StatsTable/>
                    </div>
				</div>
            );
        }
    }

function mapStateToProps(state) {
    return { state:state }
}

export default connect(mapStateToProps)(DashboardTables)